export default __webpack_public_path__ + "static/media/ffc89ff250028f8.e03f226e.mp3";